<div class="hierarchy-report-container" *ngIf="hierarchyData">
  <!-- Hierarchy Table -->
  <div class="hierarchy-table-container">
    <p-table 
      [value]="displayRows" 
      [scrollable]="true" 
      scrollHeight="70vh"
      styleClass="hierarchy-table">
      
      <!-- Header -->
      <ng-template pTemplate="header">
        <tr>
          <th class="hierarchy-name-header" style="width: 300px;">User Name</th>
          <ng-container *ngFor="let column of columns; let i = index">
            <th [ngClass]="getColumnClass(column)">
              {{ column.columnName }}
            </th>
          </ng-container>
        </tr>
      </ng-template>
      
      <!-- Body -->
      <ng-template pTemplate="body" let-row>
        <tr [ngClass]="getRowClass(row)">
          <!-- Hierarchy Name Column -->
          <td class="hierarchy-name-cell">
            <div class="flex align-items-center" 
                 [style.padding-left]="getIndent(row._level, row)">
              
              <!-- Expand/Collapse Icon: Shows on main row if node has children -->
              <!-- + icon = collapsed, - icon = expanded -->
              <i *ngIf="shouldShowExpandIcon(row)" 
                 [ngClass]="getExpandIcon(row)"
                 (click)="toggleNode(row._hierarchyId)"
                 class="cursor-pointer mr-2"
                 style="width: 16px; cursor: pointer;">
              </i>
              
              <!-- Arrow Icon: Shows on parent's own data row when expanded -->
              <i *ngIf="shouldShowArrowIcon(row)" 
                 class="pi pi-arrow-right mr-2"
                 style="width: 16px; font-size: 10px; color: #999;">
              </i>
              
              <!-- Spacer: For leaf nodes (no children) to maintain alignment -->
              <span *ngIf="shouldShowSpacer(row)" 
                    style="width: 16px; display: inline-block; margin-right: 8px;">
              </span>
              
              <!-- Node Name -->
              <span class="node-name">
                {{ row._hierarchyName }}
              </span>
            </div>
          </td>

          <!-- Data Columns (skip first column as it contains names shown in hierarchy) -->
          <ng-container *ngFor="let column of columns; let i = index">
            <td [ngClass]="getColumnClass(column)"> <a class="cursor-pointer" (click)="getDrilldownReport(row, column, 1)">{{ formatValue(getColumnValue(row, column, i+1), column) }}</a>
            </td>
          </ng-container>
        </tr>
      </ng-template>

      <!-- Empty message -->
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="columns.length" class="text-center">
            <div class="no-data-message">
              <i class="pi pi-info-circle"></i>
              <p>No hierarchy data available</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<!-- No data message -->
<div *ngIf="!hierarchyData" class="no-data-container">
  <div class="no-data-message">
    <i class="pi pi-exclamation-triangle"></i>
    <p>No hierarchy data to display</p>
  </div>
</div>
